import React, { Component } from "react";
import { connect } from "react-redux";
import { store } from "store";
import { YearGraph } from "common";
import { fetchGoogleAnalyticsSessions } from "screens/sites/actions";

class PrimarySiteSessionsByMonth extends Component {
  mounted = true;

  componentDidMount() {
    const params = {
      siteId: this.props.siteId,
      startDate: this.props.displayYOY
        ? this.props.date.year - 1 + "-01-01"
        : this.props.date.year + "-01-01",
      endDate: this.props.date.year + "-12-31",
      hash: this.props.public_hash,
      isPublic: this.props.isPublic,
    };
    this.fetchData(params);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate = (nextProps) => {
    const hasDifferentMonth = this.props.date.month !== nextProps.date.month;
    const hasDifferentYear = this.props.date.year !== nextProps.date.year;
    const hasDifferentDisplayYOY =
      this.props.displayYOY !== nextProps.displayYOY;

    if (hasDifferentMonth || hasDifferentYear || hasDifferentDisplayYOY) {
      const params = {
        siteId: this.props.siteId,
        startDate: this.props.displayYOY
          ? this.props.date.year - 1 + "-01-01"
          : this.props.date.year + "-01-01",
        endDate: this.props.date.year + "-12-31",
        hash: this.props.public_hash,
        isPublic: this.props.isPublic,
      };
      this.fetchData(params);
    }

    if (this.props.clearCacheBool !== nextProps.clearCacheBool) {
      const params = {
        siteId: this.props.siteId,
        startDate: this.props.displayYOY
          ? this.props.date.year - 1 + "-01-01"
          : this.props.date.year + "-01-01",
        endDate: this.props.date.year + "-12-31",
        hash: this.props.public_hash,
        isPublic: this.props.isPublic,
      };
      this.props.clearCacheBool === true &&
        this.props.fetchGoogleAnalyticsSessions(
          params,
          () =>
            this.mounted &&
            store.dispatch({
              type: "SET_PRIMARY_SITE_TABLES_LOAD_STATE",
              payload: { primarySiteSessionsLoadState: false },
            }),
          this.props.clearCacheBool,
          "FETCHING_PRIMARY_SITE_GA_SESSIONS"
        );
    }
  };
  fetchData = (params) => {
    if (!params.siteId) return;
    this.mounted &&
      store.dispatch({
        type: "SET_PRIMARY_SITE_TABLES_LOAD_STATE",
        payload: { primarySiteSessionsLoadState: true },
      });

    this.props.fetchGoogleAnalyticsSessions(
      params,
      () =>
        this.mounted &&
        store.dispatch({
          type: "SET_PRIMARY_SITE_TABLES_LOAD_STATE",
          payload: { primarySiteSessionsLoadState: false },
        }),
      false,
      "FETCHING_PRIMARY_SITE_GA_SESSIONS"
    );
  };

  render() {
    return (
      <YearGraph
        downloadCSV={this.props.downloadCSV}
        downloadCSVKey={this.props.downloadCSVKey}
        downloading={this.props.downloading}
        setDownloading={this.props.setDownloading}
        className={"yearly-graph no-padding padding-left "}
        title="Sessions By Month"
        yLabel="Sessions"
        isLoading={this.props.primarySiteSessionsLoadState}
        displayYOY={this.props.displayYOY}
        data={this.props.primarySiteSessions}
        year={this.props.date.year}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    date: state.sites.show.date,
    isPublic: state.sites.show.permissions.isPublic,
    public_hash: state.sites.show.data.public_hash,
    siteId: state.sites.show.data.id,
    ga_property_id: state.sites.show.data.ga_property_id,
    primarySiteSessions:
      state.sites.show.primarySiteAnalyticsData.primarySiteSessions,
    primarySiteSessionsLoadState:
      state.sites.show.primarySiteAnalyticsData.primarySiteSessionsLoadState,
  };
};

export default connect(mapStateToProps, { fetchGoogleAnalyticsSessions })(
  PrimarySiteSessionsByMonth
);
